import { render, staticRenderFns } from "./webpage-content.vue?vue&type=template&id=72593f6c&scoped=true"
import script from "./webpage-content.vue?vue&type=script&lang=ts"
export * from "./webpage-content.vue?vue&type=script&lang=ts"
import style0 from "./webpage-content.vue?vue&type=style&index=0&id=72593f6c&prod&lang=css"
import style1 from "./webpage-content.vue?vue&type=style&index=1&id=72593f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72593f6c",
  null
  
)

export default component.exports